import COM from './WatchSize'

export default COM
